import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const loading = (
  <div className="min-h-screen flex items-center justify-center">
    <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-primary-600"></div>
  </div>
);

/**
 * Portal onboarding and assessment flows call `/api/portal-candidates/*` and require a `portal_candidates` row.
 */
const RequirePortalCandidate: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { isLoading, portalCandidate } = useAuth();

  if (isLoading) {
    return loading;
  }

  if (!portalCandidate) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default RequirePortalCandidate;
